module.exports = __webpack_public_path__ + "images/help/icn-faq-payment@2x-0dba1a7477c36b7200c09458203544c1.png";